import Box from '@mui/material/Box'
import styled from '@mui/system/styled'

export const StyledWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  background: theme.palette?.background?.blue,
}))
